__turbopack_context__.v({
  "bulletIcon": "_4OTIbW_bulletIcon",
  "bulletIconToBack": "_4OTIbW_bulletIconToBack",
  "priceCell": "_4OTIbW_priceCell",
  "priceCellBestValue": "_4OTIbW_priceCellBestValue",
  "priceCellHasPrice": "_4OTIbW_priceCellHasPrice",
  "priceCellHoverable": "_4OTIbW_priceCellHoverable",
  "priceCellNoPrice": "_4OTIbW_priceCellNoPrice",
  "priceCellSelected": "_4OTIbW_priceCellSelected",
  "priceCellSelectedBestValue": "_4OTIbW_priceCellSelectedBestValue",
  "priceTextNoPrice": "_4OTIbW_priceTextNoPrice",
});
